import { Component, OnInit, inject } from '@angular/core';
import {ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup, Validators} from "@angular/forms";
import {ActivatedRoute, Router} from "@angular/router";
import {DataService} from "../../services/data.service";
import {AccessService} from "../../services/access.service";
import {BackupService} from "../../services/backup.service";
import {ToastrService} from "ngx-toastr";
import Swal from "sweetalert2";
import {ViewMode} from "../../interfaces";
import {NgIf} from "@angular/common";

@Component({
    selector: 'app-region-detail',
    imports: [NgIf, ReactiveFormsModule],
    template: `
        <div class="card">
            <div class="card-body">
                <div class="mb-4">
                    <h3>
                        <i class="fa-solid fa-map me-2"></i>
                        @switch (viewMode) {
                            @case (ViewMode.INSERT) {
                                Region anlegen
                            }
                            @case (ViewMode.EDIT) {
                                Region bearbeiten
                            }
                            @case (ViewMode.VIEW) {
                                Region
                            }
                        }
                    </h3>
                </div>

                <form [formGroup]="form">
                    <div class="row">
                        <div class="col">
                            <label>Name</label>
                            <input type="text" class="form-control" formControlName="name" *ngIf="viewMode != ViewMode.VIEW">
                            <p *ngIf="viewMode == ViewMode.VIEW">{{ form.value.name }}</p>
                        </div>
                    </div>
                </form>

                <div class="mt-3">
                    @if (viewMode == ViewMode.VIEW) {
                        <button type="button" class="btn btn-primary me-2" (click)="setMode(ViewMode.EDIT)">Bearbeiten</button>
                        <button type="button" class="btn btn-secondary" (click)="cancel()">Zurück</button>
                        <button type="button" class="btn btn-danger float-end" (click)="delete()" [disabled]="region?.stores != '0'">Löschen</button>
                    } @else if (viewMode == ViewMode.EDIT) {
                        <button type="button" class="btn btn-primary" [disabled]="form.invalid" (click)="update()">Aktualisieren</button>
                        <button type="button" class="btn btn-secondary ms-2" (click)="cancelEdit()">Abbrechen</button>
                    } @else if (viewMode == ViewMode.INSERT) {
                        <button type="button" class="btn btn-primary" [disabled]="form.invalid" (click)="save()">Speichern</button>
                        <button type="button" class="btn btn-secondary ms-2" (click)="cancel()">Abbrechen</button>
                    }
                </div>

            </div>
        </div>
    `
})
export class RegionDetailComponent implements OnInit {

    accessService = inject(AccessService);
    private router = inject(Router);
    private fb = inject(UntypedFormBuilder);
    private dataService = inject(DataService);
    private route = inject(ActivatedRoute);
    private backupService = inject(BackupService);
    private toastrService = inject(ToastrService);

    ViewMode = ViewMode;

    form!: UntypedFormGroup;
    id_region!: string;
    viewMode!: ViewMode;
    region: any;

    ngOnInit(): void {
        this.id_region = this.route.snapshot.paramMap.get('id') ?? '0';
        this.viewMode = this.id_region == '0' ? ViewMode.INSERT : ViewMode.VIEW;

        this.form = this.fb.group({
            id: [null],
            name: [null, Validators.required],
        });

        if (this.id_region !== '0') {
            this.getRegion();
        }
    }

    getRegion(): void {
        this.dataService.request('Region/get', {
            id_region: this.id_region
        }).subscribe(response => {
            this.region = response.region;

            this.patchForm();
        });
    }

    patchForm(): void {
        this.form.patchValue({
            id: this.region.id,
            name: this.region.name,
        });
    }

    save(): void {
        this.dataService.request('Region/save', {
            region: this.form.getRawValue(),
        }).subscribe(() => {
            this.router.navigate(['/region']);
            this.toastrService.success('Die Region wurde angelegt');
        });
    }

    update(): void {
        this.dataService.request('Region/update', {
            region: this.form.getRawValue(),
        }).subscribe(() => {
            this.setMode(ViewMode.VIEW);
            this.getRegion();
            this.toastrService.success('Die Region wurde aktualisiert');
        });
    }

    cancel(): void {
        this.router.navigate(['/region']);
    }

    setMode(viewMode: ViewMode): void {
        this.viewMode = viewMode;
    }

    cancelEdit(): void {
        this.patchForm();
        this.setMode(ViewMode.VIEW);
        this.getRegion();
    }

    delete(): void {
        Swal.fire({
            title: 'Sicher?',
            text: 'Die Region wird gelöscht.',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#DD6B55',
            confirmButtonText: 'Ja',
            cancelButtonText: 'Nein'
        }).then(result => {
            if (result.value) {
                this.dataService.request('Region/delete', {
                    id_region: this.id_region
                }).subscribe(() => {
                    this.cancel();
                    this.toastrService.success('Die Region wurde gelöscht');
                });
            }
        });
    }

}
